import {
    IIdentifierVm,
    IValueViewModel,
    IdentifierType,
    ObjectType,
    SelectionStrategy
} from '../../models';

export function isItself(identifier: IValueViewModel, dragObject: { guid: string; objectType: ObjectType }): string {
    let message: string;
    if (identifier.guid === dragObject.guid) {
        message = 'You can\'t drag an object on himself!';
    }
    return message;
}

export function isCorrectObjectType(_identifier: IValueViewModel, dragObject: { guid: string; objectType: ObjectType }): string {
    let message: string;
    const isDraggedIdentifier = dragObject?.objectType === 1;
    if (isDraggedIdentifier) {
        message = 'Only tags can be mapped, not identifier!';
    }
    return message;
}

export function isCorrectIdentifierType(identifier: IValueViewModel, _dragObject: { guid: string; objectType: ObjectType }): string {
    const hasCorrecType = (identifier as IIdentifierVm).type === IdentifierType.Tag
        || ((identifier as IIdentifierVm).type !== IdentifierType.Tag && identifier.selectionStrategy === SelectionStrategy.Tags);
    let message: string;
    if (!hasCorrecType) {
        message = 'Only tags can be dropped on measured identifier or target/validated identifier with tag strategy';
    }
    return message;
}

export function isTagOrValidated(identifier: IValueViewModel, _dragObject: { guid: string; objectType: ObjectType }) {
    let message: string;
    if (identifier.identifierType !== IdentifierType.Tag &&
        identifier.identifierType !== IdentifierType.Validated) {
        message = 'Tags can only be dropped on measured identifiers';
    }
    return message;
}
